import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loginLine } from "../store/Slice/authSlice";
import { Container } from "@mui/material";
import ContentPage from "../Components/ContentPage";
import HomeIcon from "@mui/icons-material/Home";
import authService from "../Services/auth.service";
import { useNavigate } from "react-router-dom";

export default function LoginLine() {
  const [callbackData, setCallbackData] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramsObject = {};

    // Iterate through the URLSearchParams entries
    params.forEach((value, key) => {
      let decodedValue = decodeURIComponent(value);

      // Try to parse the value as JSON, fallback to the string value if parsing fails
      try {
        decodedValue = JSON.parse(decodedValue);
      } catch (e) {
        // If it's not JSON, keep it as the decoded string
      }

      paramsObject[decodeURIComponent(key)] = decodedValue;
    });

    setCallbackData(paramsObject);

    if (Object.keys(paramsObject).length > 0) {
      dispatch(loginLine(paramsObject)).then(async () => {
        let user = await authService.auth();

        if (user && user.group_id === "4") {
          navigate("/defaultUser");
        } else {
          navigate("/lab");
        }
      });
    }
  }, [dispatch]); // Empty array ensures the effect runs only once

  return (
    <div>{callbackData ? "Processing login..." : "No callback data found"}</div>
  );
}
